import { Cancel, DeleteOutline, Search, Tune } from '@mui/icons-material'
import {
  Avatar,
  FormControl,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Modal } from 'react-bootstrap'
import axios from 'axios';
import pending from '../../assets/images/pending.png';
import check from '../../assets/images/Confirmed.png'
import { useSelector } from 'react-redux'
import {  Eye, EyeOff, EyeOffIcon } from 'lucide-react'
import { toast } from 'react-toastify'
import './Staff.css'
import DeleteModal from '../../components/Modals/DeleteModal'
import DatePickerDMY from '../../components/DatePickerDMY';
import pendingIcon from "../../assets/images/pending.png";
import executingIcon from "../../assets/images/Executing.png";
import executedIcon from "../../assets/images/Executed.png";
import confirmedIcon from "../../assets/images/Confirmed.png";
import { database } from "../../firebase";
import { ref, query, limitToLast, onChildAdded } from "firebase/database";

export default function SosRequests() {
  const [filterDate, setFilterDate] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const statuses = [
    { title: "Pending", icon: pending, id: "1" },
    { title: "Closed", icon: check, id: "2" },
  ];

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // sos & table data

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [sos, setSos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const getSosRequests = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/get-all-sos-requests?page=${page}&per_page=${pageSize}`,
        { headers },
      );
      console.log (response.data) ;
      const res = response.data.data;
      setSos(res.data);
      setRowCount(res?.pagination?.total);
    } catch (error) {
      console.log(error);
    }
  };

  const SosColumns = [
    {
      field: "Id",
      headerName: "Sos Id",
      flex: 0.6,
      minWidth: 80,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "0px",
          }}
        >
          <span>{params.row.Id}</span>
          {(params.row.rawData?.is_read === "0" ||
            newSosIds.has(params.row.id)) && (
            <span className="new-badge">NEW</span>
          )}
        </div>
      ),
    },
    {
      field: "recipients",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "van",
      headerName: "Van ID",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "problem",
      headerName: "Problem Type",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "Created",
      headerName: "Created at",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "unreadCount",
      headerName: "Status",
      width: 150,
    },
{
  field: "Actions",
  headerName: "Actions",
  flex: 0.8,
  minWidth: 90,
  renderCell: (params) => {
    const isRead = params.row.rawData?.is_read === "1";

    const handleView = async (event) => {
      event.stopPropagation();
      if (!isRead) {
        await toggleReadStatus(params.row.rawData);
      }
      handleViewModalOpen(params.row.rawData);
    };

    const handleDelete = (event) => {
      event.stopPropagation();
      confirmDelete(params.row.id);
    };

    const handleToggleRead = async (event) => {
      event.stopPropagation();
      await toggleReadStatus(params.row.rawData);
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          overflow: "visible",
          whiteSpace: "nowrap",
        }}
      >
        <IconButton onClick={handleView} color="default" aria-label="view">
          <Eye />
        </IconButton>
        <IconButton onClick={handleDelete} color="error" aria-label="delete">
          <DeleteOutline />
        </IconButton>
        {isRead && (
          <IconButton onClick={handleToggleRead} color="default" aria-label="mark-unread">
            <EyeOffIcon size={20} />
          </IconButton>
        )}
      </div>
    );
  },
},
  ];

  const rows = sos
    .filter((sos) => {
      const matchesSearch =
        sos.creator?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sos.status?.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesSearch;
    })
    .map((sos) => ({
      id: sos.id,
      Id: sos.id,
      recipients: sos.creator?.name,
      van: sos.creator?.current_vehicle?.name || "",
      problem: sos.type || "",
      Created: formatDate(sos.created_at) || "None",
      unreadCount: sos.status,
      Actions: "",
      rawData: sos,
    }));

  //  view modal data

  const [viewData, setViewData] = useState(null);

  const [viewModalOpen, setViewModalOpen] = useState(false);

  const handleViewModalOpen = (data) => {
    setViewData(data);
    console.log(data);
    setHasError(false);
    setViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setViewModalOpen(false);
  };

  const imageUrl = viewData?.image_url ? `${viewData.image_url}` : null;

  const [hasError, setHasError] = useState(false);

  const handleDownload = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = imageUrl.split("/").pop() || "sos-image.png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  // delete sos functions

  const [showDelete, setShowDelete] = useState(false);
  const [sosId, setSosId] = useState(null);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setSosId(null);
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setSosId(id);
  };

  const deleteSos = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/sos-delete/${sosId}`,
        {
          headers,
        },
      );
      toast.warning("Sos Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getSosRequests();
    } catch (error) {
      toast.error("Failed To Delete This Sos.");
      console.log(error.message);
    }
  };

  // reply to sos

  const [replyOpen, setReplyOpen] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(viewData?.status || "");
  const [sendingReply, setSendingReply] = useState(false);

  useEffect(() => {
    if (viewData?.status) {
      setSelectedStatus(viewData.status);
    }
  }, [viewData]);

  const handleSendReply = async () => {
    if (!replyText.trim()) return;
    setSendingReply(true);
    try {
      const formData = new FormData();
      formData.append("response_content", replyText);
      formData.append("status", selectedStatus);
      await axios.post(
        `${newBaseUrl}/api/portal/sos-reply/${viewData?.id}`,
        formData,
        { headers },
      );
      setReplyOpen(false);
      setReplyText("");
      handleViewModalClose();
      toast.success("Reply sent successfully", { autoClose: 3000 });
      getSosRequests();
    } catch (error) {
      console.log(error);
    } finally {
      setSendingReply(false);
    }
  };

  const STATUS_CONFIG = {
    pending: {
      label: "Pending",
      icon: pendingIcon,
      color: "#f59e0b",
    },
    in_progress: {
      label: "In Progress",
      icon: executingIcon,
      color: "#3b82f6",
    },
    resolved: {
      label: "Resolved",
      icon: executedIcon,
      color: "#10b981",
    },
    closed: {
      label: "Closed",
      icon: confirmedIcon,
      color: "#6b7280",
    },
  };

  // effects

  useEffect(() => {
    getSosRequests();
  }, [page, pageSize]);

  useEffect(() => {
    setHasError(false);
  }, [imageUrl]);

  // *********************** firebase ************************

const [newSosIds, setNewSosIds] = useState(new Set());

const clearNewSos = (id) => {
  setNewSosIds((prev) => {
    const next = new Set(prev);
    next.delete(id);
    return next;
  });
};

const toggleReadStatus = async (row) => {
  try {
    await axios.post(
      `${newBaseUrl}/api/portal/sos-toggle-read/${row.id}`,
      {},
      { headers },
    );
    setSos((prev) =>
      prev.map((s) =>
        s.id === row.id ? { ...s, is_read: s.is_read === "1" ? "0" : "1" } : s,
      ),
    );
    if (row.is_read === "0") {
      clearNewSos(row.id);
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};

useEffect(() => {
  if (!token) return;
  const pageOpenTime = Date.now();
  const liveSosRef = query(ref(database, "sos_requests"), limitToLast(5));
  const unsubscribe = onChildAdded(liveSosRef, (snapshot) => {
    const data = snapshot.val();
    console.log(data);
    const recordTime = new Date(data.created_at).getTime();
    if (recordTime < pageOpenTime) return;
    setTimeout(() => {
      axios
        .get(`${newBaseUrl}/api/portal/get-all-sos-requests`, {
          headers,
          params: { id: data.id },
        })
        .then((res) => {
          console.log(res);
          const newSos = res.data.data.data?.[0];
          if (!newSos) return;
   setSos((prev) => {
     if (prev.find((s) => s.id === newSos.id)) return prev;
     return [{ ...newSos, is_read: "0" }, ...prev]; 
   });
          setRowCount((prev) => prev + 1);
          setNewSosIds((prev) => new Set([...prev, newSos.id]));
        })
        .catch(console.error);
    }, 8000);
  });
  return () => unsubscribe();
}, [token]);
  
  // *********************** firebase ************************

  return (
    <>
      {/* view sos modal */}
      <Modal show={viewModalOpen} onHide={handleViewModalClose}>
        <Modal.Header className="categories_header bg-white border-0 pb-0">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center w-100 pb-0 mb-0">
            <div>
              <p className="my-0 small fw-bold">SOS #{viewData?.id}</p>
              <p className="text-muted my-0" style={{ fontSize: "15px" }}>
                {formatDate(viewData?.created_at)}
              </p>
            </div>
            {/* ✅ Status Dropdown + زرار الإغلاق */}
            <div className="d-flex align-items-center gap-2">
              {viewData?.status !== "closed" ? (
                <div className="dropdown ">
                  <button
                    className="btn btn-light border d-flex align-items-center gap-2 px-2 py-1"
                    style={{ fontSize: "13px", borderRadius: "8px" }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {STATUS_CONFIG[selectedStatus]?.icon && (
                      <img
                        src={STATUS_CONFIG[selectedStatus]?.icon}
                        alt={selectedStatus}
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    <span
                      style={{
                        color: STATUS_CONFIG[selectedStatus]?.color,
                        fontWeight: 600,
                      }}
                    >
                      {STATUS_CONFIG[selectedStatus]?.label || selectedStatus}
                    </span>
                    <i
                      className="bi bi-chevron-down"
                      style={{ fontSize: "11px" }}
                    />
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end shadow border-0"
                    style={{ minWidth: "170px", borderRadius: "10px" }}
                  >
                    {Object.entries(STATUS_CONFIG).map(([key, config]) => (
                      <li key={key}>
                        <button
                          className="dropdown-item d-flex align-items-center gap-2 py-2"
                          style={{ fontSize: "13px" }}
                          onClick={() => setSelectedStatus(key)}
                        >
                          <img
                            src={config.icon}
                            alt={key}
                            style={{
                              width: "18px",
                              height: "18px",
                              objectFit: "contain",
                            }}
                          />
                          <span
                            style={{
                              color: config.color,
                              fontWeight: selectedStatus === key ? 700 : 400,
                            }}
                          >
                            {config.label}
                          </span>
                          {selectedStatus === key && (
                            <i
                              className="bi bi-check2 ms-auto"
                              style={{ color: config.color }}
                            />
                          )}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="d-flex justify-content-start align-items-center bg-light rounded-2 px-3 py-2">
                  <img src={confirmedIcon} alt="closed" className="me-2" />
                  <p className="my-0" style={{ fontSize: "14px" }}>
                    {viewData.status}
                  </p>
                </div>
              )}
              {/* زرار الإغلاق */}
              <div className="cursor mb-2" onClick={handleViewModalClose}>
                <Cancel />
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-1 px-3">
          {/* name */}
          <div className="mx-1 my-3 border-bottom border-1">
            <p className="text-muted my-2">Employee Name</p>
            <div className="d-flex justify-content-start align-items-center mb-3">
              <Avatar
                src={`https://estbn.com/EstbnNew/public/${viewData?.creator?.profile_photo_path}`}
              />
              <p className="my-0 mx-2 fw-semibold">{viewData?.creator?.name}</p>
            </div>
          </div>
          {/* created */}
          <div className="mx-1 my-3 border-bottom border-1">
            <p className="text-muted mb-0">Created at</p>
            <p className="fw-semibold">{formatDate(viewData?.created_at)}</p>
          </div>
          {/* van & type */}
          <div className="mx-1 my-3 border-bottom border-1 d-flex justify-content-start align-items-center">
            <div className="col-4">
              <p className="text-muted mb-0">Van ID</p>
              <p className="fw-semibold">
                {viewData?.creator?.current_vehicle?.id}
              </p>
            </div>
            <div className="col-4">
              <p className="text-muted mb-0">Problem Type</p>
              <p className="fw-semibold">{viewData?.type}</p>
            </div>
          </div>
          {/* description */}
          <div className="mx-1 my-3 border-bottom border-1">
            <p className="text-muted mb-0">Description</p>
            <p className="fw-semibold">{viewData?.description}</p>
          </div>
          {/* image */}
          {imageUrl && !hasError && (
            <div className="mx-1 my-3">
              <div className="sos-image-container">
                <img
                  src={imageUrl}
                  alt="Description"
                  onError={() => setHasError(true)}
                />
                <button className="download-btn" onClick={handleDownload}>
                  Download
                </button>
              </div>
            </div>
          )}
          {/* ✅ Textarea بتظهر لما replyOpen = true */}
          {replyOpen && (
            <div className="mx-1 mb-3">
              <textarea
                className="form-control"
                rows={3}
                placeholder="Reply..."
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                style={{
                  borderRadius: "10px",
                  resize: "none",
                  fontSize: "14px",
                }}
              />
            </div>
          )}
          {/* ✅ الزرار بيتبدل */}
          {viewData?.status !== "closed" &&
            (!replyOpen ? (
              <button
                className="btn btn-dark w-100"
                onClick={() => setReplyOpen(true)}
              >
                Reply to SOS #{viewData?.id}
              </button>
            ) : (
              <button
                className="btn btn-dark w-100"
                onClick={handleSendReply}
                disabled={sendingReply || !replyText.trim()}
              >
                {sendingReply ? "Sending..." : "Send"}
              </button>
            ))}
        </Modal.Body>
      </Modal>
      {/* delete sos */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this note?"}
        deleteFunction={deleteSos}
      />
      <div className="m-4">
        {/* Header Note */}
        <div className="">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="m-0">Sos</h5>
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div
              className="d-flex align-items-center gap-3"
              style={{ width: "70%" }}
            >
              <div className="w-50">
                <FormControl
                  className="m-0"
                  fullWidth
                  variant="outlined"
                  size="small"
                >
                  <OutlinedInput
                    id="search-orders"
                    placeholder="Search for note ID, employee name, or date ..."
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
              <div className="w-25 d-flex align-items-center gap-2">
                <DatePickerDMY
                  value={filterDate}
                  onChange={(iso) => setFilterDate(iso)}
                />
                {filterDate && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light"
                    style={{ padding: "2px 6px", fontSize: "12px" }}
                    onClick={() => setFilterDate("")}
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
            <div className="">
              <div
                onClick={(e) => setAnchorEl(e.currentTarget)}
                className="btn btn-light"
              >
                <Tune style={{ cursor: "pointer" }} />
              </div>

              <Menu
                className="my-1"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                  sx: {
                    p: 1,
                    minWidth: 150,
                    backgroundColor: "#F9F9F9",
                    borderRadius: "10px",
                  },
                }}
              >
                {statuses.map((item) => (
                  <div className="">
                    <MenuItem
                      key={item.value}
                      onClick={() => {
                        console.log(item.value);
                        setAnchorEl(null);
                      }}
                    >
                      <div className="p-2 d-flex gap-3 align-items-center">
                        <img src={item.icon} alt="" />
                        <div className="label-size m-0">{item.title}</div>
                      </div>
                    </MenuItem>
                  </div>
                ))}
              </Menu>
            </div>
          </div>
        </div>
        {/* Table Note */}
        <div className="my-4">
          <div className="data-grid-small">
            <Paper sx={{ height: "auto", width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={SosColumns}
                pagination
                paginationMode="server"
                rowCount={rowCount}
                pageSizeOptions={[5, 10, 20, 50]}
                paginationModel={{
                  page: page - 1,
                  pageSize: pageSize,
                }}
                onPaginationModelChange={(model) => {
                  setPage(model.page + 1);
                  setPageSize(model.pageSize);
                }}
                getRowClassName={(params) =>
                  params.row.rawData?.is_read === "0" ||
                  newSosIds.has(params.row.id)
                    ? "new-sos-row"
                    : ""
                }
                getRowHeight={() => "auto"}
                sx={{
                  "& .MuiDataGrid-cell": {
                    py: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              />
            </Paper>
          </div>
        </div>
      </div>
    </>
  );
}

